import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import { blogPosts } from "@/data/blogPosts";

/**
 * "From the blog" section for the Lead Gen Tools landing page. Surfaces the
 * three most recent posts (the array is ordered newest-first) in the dark
 * landing palette and links through to the full /blogs index.
 */
export default function FromTheBlog() {
  const posts = blogPosts.slice(0, 3);

  return (
    <section className="relative bg-[#0d0d14] py-24 lg:py-28">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="mb-12 text-center">
          <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-fuchsia-400">
            From the blog
          </div>
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Local SEO insights and playbooks
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-white/60">
            Practical guides on Google Business Profile, local rankings, and turning audits into clients.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((post) => {
            const card = (
              <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-gradient-to-br from-[#13131c] to-[#0c0c14] p-6 transition-colors group-hover:border-fuchsia-500/30">
                <span className="mb-3 inline-flex w-fit rounded-full bg-violet-500/15 px-3 py-1 text-xs font-medium text-violet-300">
                  {post.category}
                </span>
                <h3 className="mb-3 text-lg font-bold leading-snug text-white">
                  {post.title}
                </h3>
                <p className="mb-5 line-clamp-3 text-[14.5px] leading-relaxed text-white/60">
                  {post.excerpt}
                </p>
                <div className="mt-auto flex items-center gap-4 text-xs text-white/45">
                  <span className="inline-flex items-center gap-1">
                    <Calendar className="h-3.5 w-3.5" />
                    {post.publishDate}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <Clock className="h-3.5 w-3.5" />
                    {post.readTime}
                  </span>
                </div>
              </div>
            );

            return post.slug.startsWith("/") ? (
              <Link key={post.id} to={post.slug} className="group">
                {card}
              </Link>
            ) : (
              <a
                key={post.id}
                href={post.slug}
                target="_blank"
                rel="noopener noreferrer"
                className="group"
              >
                {card}
              </a>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/blogs"
            className="inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/5"
          >
            View all articles
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
